// src/components/Header.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Header.css';

const Header = () => {
  const [user, setUser] = useState({ email: '', role: '' });
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios
        .get('/api/member/profile', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setUser({ email: res.data.email, role: res.data.role });
        })
        .catch((err) => console.error(err));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const getInitials = (email) => {
    return email ? email.substring(0, 2).toUpperCase() : 'AD';
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <h1 className="header-title">Dashboard Métaux Précieux</h1>
      </div>
      
      <div className="header-right">
        <button className="notification-btn" title="Notifications">
          <span className="notification-icon">🔔</span>
          <span className="notification-badge">3</span>
        </button>
        
        <div className="user-profile-container">
          <button 
            className="user-profile-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="user-avatar">
              {getInitials(user.email)}
            </div>
            <div className="user-info">
              <span className="user-name">{user.email || 'Admin'}</span>
              <span className="user-role">{user.role === 'admin' ? 'Administrateur' : 'Utilisateur'}</span>
            </div>
            <span className="dropdown-arrow">▼</span>
          </button>
          
          {showDropdown && (
            <div className="user-dropdown">
              <button className="dropdown-item" onClick={() => navigate('/dashboard')}>
                <span className="dropdown-icon">👤</span>
                Mon Profil
              </button>
              <button className="dropdown-item" onClick={() => navigate('/create-token')}>
                <span className="dropdown-icon">🔑</span>
                Mes Tokens
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout" onClick={handleLogout}>
                <span className="dropdown-icon">🚪</span>
                Déconnexion
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;

